import Vue from 'vue';

import { EarlyWarningDirective } from './earlyWarning.directive';
import { TmsShowMenuOnHover } from './tmsShowMenuOnHover.directive';

Vue.directive('tms-show-menu-on-hover', TmsShowMenuOnHover);
Vue.directive('early-warning', EarlyWarningDirective);
